import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { CircleWavyWarning, CircleTick, IconTag, CalendarBlank } from '../assets/images/icons/icons';
import { monthNames } from '../data/javascript-functions';
import GetCostEstimates from '../data/platform/cost-estimations/lookup';
import { Console } from './../services/platform-api';
import help_icon from '../../src/assets/images/icons/help.svg';
import { useSessionStorage } from '../hooks/useSessionStorage';

const CombinationSideBar = (props) => {
  let time_zone = useSessionStorage('time_zone', '');
  let offset = time_zone[0].match(/\d+/); // extracts the hour

  const [estimatedCost, setEstimatedCost] = useState(25);
  const [apiCalls, setApiCalls] = useState(100);
  const [currency, setCurrency] = useState('');
  const [cycle, setCycle] = useState('');

  const costsData = GetCostEstimates(props.recipeDetails.id);

  let nf = new Intl.NumberFormat('en-US');

  const recipeDetails = props.recipeDetails;
  let updated_at = '';
  if (recipeDetails.updated_at) {
    var ds_check_date = new Date();
    var ds_offset = ds_check_date.getTimezoneOffset();
    // Determine timezone
    // if (offset < 0) {
    //   timezone = 'UTC+' + (-1 * offset) / 60;
    // } else {
    //   timezone = 'UTC-' + offset / 60;
    // }
    // console.log('Timezone: ' + timezone);
    // Determine if Daylight Savings Time is in effect
    if (ds_offset < 0) {
      offset += 1;
    }

    // workato date time is not UTC so we calculate back to utc then apply the hour offset from our users chosen time zone.
    let date = new Date(recipeDetails.updated_at);

    offset = Number(offset); // converts to a number
    let daylightSavings = date.getTimezoneOffset(); // get the offset (in minutes) from UTC for the current date
    let utc = date.getTime() + daylightSavings * 60000; // calculate back to UTC
    let newDate = new Date(utc + 3600000 * offset); // apply the hour offset from our users chosen time zone

    updated_at =
      monthNames[newDate.getMonth()] +
      ' ' +
      newDate.getDate() +
      ' ' +
      newDate.getFullYear() +
      ' at ' +
      newDate.toLocaleTimeString();
  }

  const calculateEstimatedCost = (priceBreak, numApiCalls) => {
    const calcd = priceBreak.base_price + priceBreak.per_request * numApiCalls;
    return parseFloat(calcd.toFixed(2));
  };

  useEffect(() => {
    if (!costsData) return;
    const priceBreak = costsData[0];
    setCurrency(priceBreak.currency);
    setCycle(priceBreak.cycle);
    const estimatedCost = calculateEstimatedCost(priceBreak, apiCalls);
    setEstimatedCost(estimatedCost);
  }, [costsData, apiCalls]);

  const handleChange = (e) => {
    e.preventDefault();
    const numApiCalls = e.target.value;
    setApiCalls(numApiCalls);

    const limited = costsData.filter((price_break) => price_break.numbers >= numApiCalls);
    if (limited.length > 0) {
      const priceBreak = limited[0];
      const estimatedCost = calculateEstimatedCost(priceBreak, numApiCalls);
      setEstimatedCost(estimatedCost);
    } else {
      // handle the case when limited is empty
    }
  };

  return (
    <>
      <Row>
        <Col>
          <div className={`card card-workflows p-2 ${props.recipeStatus === true ? 'recipe_active' : ''} `}>
            {props.recipeStatus === true ? (
              <>
                <div data-testid={`recipe-active`}>
                  <img height="25px" src={CircleTick} alt="" />
                  &nbsp;Active
                </div>
              </>
            ) : (
              <>
                <div data-testid={`recipe-inactive`}>
                  <img height="25px" src={CircleWavyWarning} alt="" />
                  &nbsp;Inactive
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="text-center eggplant-100-bg p-2 m-2">
          <label htmlFor="name" className="label">
            Successful Jobs
          </label>

          <br />
          <h1>{recipeDetails.job_succeeded_count}</h1>
        </Col>
        <Col className="text-center peach-600-bg p-2 m-2">
          <label htmlFor="name" className="label">
            Failed Jobs
          </label>

          <br />
          <h1>{recipeDetails.job_failed_count}</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <label className="label">Location</label>
          <br />
          <img height="17px" src={IconTag} alt="Recipe Location" /> &nbsp;
          {recipeDetails.location}
        </Col>
      </Row>
      <hr className="hr" />
      <Row>
        <Col>
          <label className="label">Description</label>
          <br />
          {recipeDetails.description}
          {/* <img height="17px" src={Edit} alt="Recipe Location" /> &nbsp; */}
        </Col>
      </Row>
      <hr className="hr" />
      <Row>
        <Col>
          <label className="label">Estimated additional fees on top of your chosen subscription</label>
          <br />
          {currency} {nf.format(estimatedCost)}
          <div className="tooltip">
            <img src={help_icon} className="tooltip_icon" alt="help" />
            <span className="tooltiptext">
              An estimation of the running fees your AWS environment will charge to help you predict the total budget
              needed for your project
            </span>
          </div>
          <br />
          <label className="label">API Calls</label>
          <input
            onChange={handleChange}
            type="range"
            min={100}
            max={1000000}
            step={100}
            value={apiCalls.toLocaleString()}
            className="form-range"
            id="customRange1"
          ></input>
          <br />
          {nf.format(apiCalls)}
          <br /> <br />
          <label className="label">Period</label>
          <br />
          {cycle.charAt(0).toUpperCase() + cycle.slice(1)}
        </Col>
      </Row>

      <hr className="hr" />
      <Row>
        <Col>
          <label htmlFor="name" className="label">
            Edited
          </label>
          <br />
          <img height="17px" src={CalendarBlank} alt="Date Last Edited" /> &nbsp;
          {updated_at}
        </Col>
      </Row>
      <hr className="hr" />
    </>
  );
};

export { CombinationSideBar };
